module.exports = __webpack_public_path__ + "static/media/memes.665cc653.jpg";